import React from "react";
import styled from "styled-components";

import { Workspace } from "@examspark/types";

const Styled = styled.div`
  background-color: #fff;
  border-radius: 0.25rem;
  font-size: 0.9rem;
  color: #333;
  display: flex;
  align-items: center;
  padding: 0.4rem;
  box-sizing: border-box;
  min-height: 2.2rem;
  text-align: center;
  margin: 0.5rem;
  width: fit-content;
`;

const WorkspaceBadge = (props: { workspace: Workspace }) => {
  if (!props.workspace?.name) return null;
  return <Styled>{props.workspace?.name}</Styled>;
};

export default WorkspaceBadge;
